/** Max scroll depth as percent of document height (0–100). */
export function computeScrollDepthPercent(doc: Document = document): number {
  const el = doc.documentElement;
  const scrollHeight = Math.max(
    el.scrollHeight,
    doc.body?.scrollHeight ?? 0,
  );
  const viewport =
    (typeof window !== 'undefined' ? window.innerHeight : 0) ||
    doc.documentElement.clientHeight ||
    0;
  if (scrollHeight <= 0 || viewport <= 0) return 0;

  const scrollY = typeof window !== 'undefined' ? window.scrollY : 0;
  const scrolled = scrollY + viewport;
  return Math.min(100, Math.round((scrolled / scrollHeight) * 100));
}
